import { db } from "../firebase/firebase";
import { doc, getDoc, updateDoc, setDoc } from "firebase/firestore";

export const syncGuestFamilyToPublicSite = async ({
  uid,
  slug,
  collectionName,
  familyDocId,
}) => {
  if (!uid || !slug || !collectionName || !familyDocId) {
    throw new Error("Missing sync parameters.");
  }

  const privateRef = doc(db, "users", uid, collectionName, familyDocId);
  const publicRef = doc(db, "sites", slug, collectionName, familyDocId);

  const privateSnap = await getDoc(privateRef);

  if (!privateSnap.exists()) {
    throw new Error("Private guest family not found.");
  }

  const privateData = privateSnap.data();

  const publicSnap = await getDoc(publicRef);

  if (publicSnap.exists()) {
    await updateDoc(publicRef, {
      familyName: privateData.familyName || "",
      guestType: privateData.guestType || "",
      guests: Array.isArray(privateData.guests) ? privateData.guests : [],
      createdBy: privateData.createdBy || "unknown",
      createdAt: privateData.createdAt || null,
    });
  } else {
    await setDoc(publicRef, {
      familyName: privateData.familyName || "",
      guestType: privateData.guestType || "",
      guests: Array.isArray(privateData.guests) ? privateData.guests : [],
      createdBy: privateData.createdBy || "unknown",
      createdAt: privateData.createdAt || null,
    });
  }
};